import { render, staticRenderFns } from "./Instancia.vue?vue&type=template&id=88c42ce0&"
import script from "./Instancia.vue?vue&type=script&lang=js&"
export * from "./Instancia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports